import { render, staticRenderFns } from "./FormComentarioReporte.vue?vue&type=template&id=2d8d9d9e&"
import script from "./FormComentarioReporte.vue?vue&type=script&lang=js&"
export * from "./FormComentarioReporte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports